<breadcrumb endText="Exam Submissions" [navigations]="breadcrumNav" />
<div class="m-5">
  <div class="font-bold text-xl">
    {{examTitle}}
  </div>
  <hr class="mt-3"/>
  <div class="grid grid-cols-6 mt-5 font-bold">
    <div class="col-span-2">
      Name
    </div>
    <div>
      Mode
    </div>
    <div>
      Start Date
    </div>
    <div>
      Answer Date
    </div>
    <div>

    </div>
  </div>
  <hr class="mt-2"/>
  @for (submission of submissionResponse; track submission; let i = $index) {
    <div [ngClass]="i%2 === 0? 'grid grid-cols-6 mt-2 text-left p-2': 'grid grid-cols-6 mt-2 p-2 rounded-[8px] bg-gray-100'">
      <div class="col-span-2">
        {{submission.display_name}}
      </div>
      <div>
        {{submission.mode}}
      </div>
      <div>
        @if (submission.start_time == null) {
          <div>
            No Start Date
          </div>
        }
        @if (submission.start_time != null) {
          <div>
            {{submission.start_time | date: 'short'}}
          </div>
        }
      </div>
      <div>
        @if (submission.answer_time == null) {
          <div>
            No Answer Date
          </div>
        }
        @if (submission.answer_time != null) {
          <div>
            {{submission.answer_time | date: 'short'}}
          </div>
        }
      </div>
      <div>
        <dropdown-menu [menuItems]="submission.menuItems" aria-label="Submission Label" />
      </div>
    </div>
  }
  @if (submissionResponse.length === 0) {
    <div class="mt-2 text-center">
      No Submissions
    </div>
  }
  @if (submissionResponse.length !== 0) {
    <per-page-pagination
      [(currentPagination)]="currentPagination"
      perPageText="Submissions"
      (perPageFunction)="handleSubmissionResponse(course_id)"
      (decrementPageFunction)="handleSubmissionResponse(course_id)"
      (incrementPageFunction)="handleSubmissionResponse(course_id)"
      />
  }
</div>
